import { render, staticRenderFns } from "./MSelectColorSidecoverTxt.vue?vue&type=template&id=18c78bdc&"
import script from "./MSelectColorSidecoverTxt.vue?vue&type=script&lang=ts&"
export * from "./MSelectColorSidecoverTxt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports